import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import $ from 'jquery';
import { withRouter } from 'react-router-dom';
import {
  apenasNumero, renderField, renderFieldCpf, renderFieldNumeros
} from '../../util/inputs';
import buscarReservasReimpressao from '../../actions/reserva/buscarReservasReimpressao';

const selector = formValueSelector('formImpressaoRecibo');

const camposBusca = ['numeroPedido', 'cpf', 'documentoComFoto'];

export class ModalImpressaoReciboPedido extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      reservas: null,
      reservaSelecionada: null
    };
  }

  fecharModal () {
    this.limparPesquisa();
    this.props.reset();
    $('#modalImpressaoReciboPedido')
      .modal('hide');
    $('#modalImpressaoReciboPedido')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  limparPesquisa () {
    this.setState({ reservas: null, reservaSelecionada: null });
  }

  selecionarCampoBusca (campoSelecionado) {
    this.limparPesquisa();
    camposBusca
      .filter(campo => campo !== campoSelecionado)
      .forEach(campo => this.props.changeFieldValue('formImpressaoRecibo', campo, null));
  }

  cpfInformado () {
    return this.props.cpf && apenasNumero(this.props.cpf).length === 11;
  }

  documentoInformado () {
    return this.props.documentoComFoto && this.props.documentoComFoto.trim() !== '';
  }

  buscarReservas () {
    const parametros = {
      cpf: this.cpfInformado() ? apenasNumero(this.props.cpf) : null,
      documentoComFoto: this.documentoInformado() ? this.props.documentoComFoto.trim() : null,
      idEmpresa: this.props.empresaSelecionada.id
    };
    this.props.buscarReservasReimpressao(parametros)
      .then(reservas => this.setState({ reservas, reservaSelecionada: null }));
  }

  submit (values) {
    if (this.state.reservaSelecionada) {
      // Abre o recibo em nova aba para manter a pesquisa no modal
      window.open(`/recibo-passagem?pedido=${this.state.reservaSelecionada.pedidoId}`, '_blank');
      return;
    }
    if (values.numeroPedido) {
      this.fecharModal();
      this.props.history.push(`/recibo-passagem?pedido=${values.numeroPedido}`);
      return;
    }
    if (this.cpfInformado() || this.documentoInformado()) {
      this.buscarReservas();
    }
  }

  exibirReservas () {
    if (!this.state.reservas) {
      return '';
    }
    return (
      <div className="vx-modal-section">
        <div className="vx-modal-section-title">
          <span className="material-icons">confirmation_number</span>
          Reservas encontradas
        </div>
        {this.state.reservas.length === 0
          ? <span>Nenhuma reserva em itinerário do dia ou em aberto encontrada.</span>
          : this.state.reservas.map(reserva => <div className='row mt-2' key={reserva.id}>
            <div>
              <input type="radio" onChange={() => this.setState({ reservaSelecionada: reserva })}
                     checked={!!this.state.reservaSelecionada && this.state.reservaSelecionada.id === reserva.id}/>
              <span className='ml-2'>
                pedido {reserva.pedidoId} reserva {reserva.id} {reserva.descCidadeOrigem}-{reserva.descCidadeDestino} Poltrona: {reserva.numeroPoltrona} Rota: {reserva.idRota} Itinerário: {reserva.idItinerario}
              </span><br/>
              <span className='ml-4'>{reserva.nomePassageiro}{reserva.dataHoraPartida ? ` · ${reserva.dataHoraPartida}` : ''}</span>
            </div>
          </div>)}
      </div>
    );
  }

  render () {
    const {
      handleSubmit, submitting, numeroPedido
    } = this.props;
    const podeBuscar = this.cpfInformado() || this.documentoInformado();
    const podeImprimir = !!this.state.reservaSelecionada || !!numeroPedido;
    return (
      <div className="modal fade" id='modalImpressaoReciboPedido' role='dialog'
           aria-labelledby='modalImpressaoReciboPedido' aria-hidden='true' data-backdrop='static'>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">receipt_long</span>
                Emitir Cupom / Recibo
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar"
                      onClick={this.fecharModal.bind(this)}>
                <span className="material-icons">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="vx-modal-body" style={{background: '#fff'}}>
                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <span className="material-icons">tag</span>
                    Número do pedido
                  </div>
                  <div onClick={() => this.selecionarCampoBusca('numeroPedido')}>
                    <Field name="numeroPedido" type="text" component={renderFieldNumeros}
                           label="Número do pedido:"
                           css="form-control" readOnly={false}/>
                  </div>
                </div>

                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <span className="material-icons">search</span>
                    Ou pesquisar reservas do passageiro
                  </div>
                  <div onClick={() => this.selecionarCampoBusca('cpf')}>
                    <Field name="cpf" type="text" component={renderFieldCpf}
                           label="CPF do passageiro:" css="form-control"/>
                  </div>
                  <div onClick={() => this.selecionarCampoBusca('documentoComFoto')}>
                    <Field name="documentoComFoto" type="text" component={renderField}
                           label="Número do documento com foto:" max={22} css="form-control"/>
                  </div>
                  <div className="d-flex justify-content-end mt-2">
                    <button type="button" disabled={!podeBuscar}
                            className={podeBuscar ? 'vx-btn-success' : 'vx-modal-btn-fechar'}
                            onClick={() => this.buscarReservas()}>
                      <span className="material-icons" style={{fontSize: '16px'}}>search</span>
                      Buscar
                    </button>
                  </div>
                </div>

                {this.exibirReservas()}
              </div>

              <div className="vx-modal-footer">
                <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                        onClick={this.fecharModal.bind(this)}>
                  Cancelar
                </button>
                <button type="submit" disabled={!podeImprimir || submitting}
                        className="vx-modal-btn-confirmar">
                  <span className="material-icons" style={{fontSize: '16px'}}>print</span>
                  Imprimir
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  numeroPedido: selector(state, 'numeroPedido'),
  cpf: selector(state, 'cpf'),
  documentoComFoto: selector(state, 'documentoComFoto')
});

export default withRouter(connect(mapStateToProps, {
  buscarReservasReimpressao,
  changeFieldValue
})(reduxForm({
  form: 'formImpressaoRecibo',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalImpressaoReciboPedido)));
